export enum UserType{
  ENTERPRISE_USER = "ENTERPRISE_USER",
  SERVICEPROVIDER_USER = "SERVICEPROVIDER_USER"
}


// WEBPACK FOOTER //
// ./src/app/shared/model/user-type.ts